import { render, staticRenderFns } from "./WorkSchedules.vue?vue&type=template&id=bb44d2de&"
import script from "./WorkSchedules.vue?vue&type=script&lang=ts&"
export * from "./WorkSchedules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports